import { GitHub } from '@/Assets/Icons/GitHub';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { ArrowRight } from '../../../../Assets/Icons/ArrowRight';
import peckShield from '../../../../Assets/Icons/PeckShield.png';
import Quantstamp from '../../../../Assets/Icons/Quantstamp.png';
import YevheniiBezuhlyiAvatar from '../../../../Assets/images/YevheniiBezuhlyiAvatar.png';
import { ROUTES } from '../../../../constants/routes.constants';
import auditsBg from './bg.png';
import './styles.css';

export function Audits() {
  const targetRef = useRef(null);
  const isInView = useInView(targetRef, {
    once: true,
    margin: '0% 0% -30% 0%',
  });

  return (
    <div className="main-page--audits" ref={targetRef}>
      <motion.div
        animate={{
          opacity: isInView ? 1 : 0,
        }}
        transition={{ duration: 0.5 }}
        className="main-page--audits-bg"
      >
        <img src={auditsBg} alt="" draggable={false} />
      </motion.div>
      <motion.h2
        animate={{
          y: isInView ? 0 : 50,
          opacity: isInView ? 1 : 0,
        }}
        transition={{ duration: 0.5 }}
        className="main-page--audits-heading"
      >
        Secured by the Industry Leaders
      </motion.h2>
      <motion.p
        animate={{
          y: isInView ? 0 : 50,
          opacity: isInView ? 1 : 0,
        }}
        transition={{ duration: 0.5, delay: 0.5 }}
        className="main-page--audits-description"
      >
        Infrastructure building according to industry standards, regular
        security audit of new features, security monitoring
      </motion.p>
      <motion.a
        animate={{
          y: isInView ? 0 : 50,
          opacity: isInView ? 1 : 0,
        }}
        transition={{ duration: 0.5, delay: 1 }}
        href="https://github.com/retro-bridge"
        target="_blank"
        rel="noopener noreferrer"
        className="main-page--audits-btn btnGradient"
      >
        Github <GitHub width={16} height={16} />
      </motion.a>
      <div className="d-flex flex-column flex-sm-row align-items-center gap-2 gap-sm-4 overflow-hidden">
        <motion.a
          animate={{
            x: isInView ? 0 : -50,
            opacity: isInView ? 1 : 0,
          }}
          viewport={{ margin: '-30%', once: true }}
          href={ROUTES.MONITORING_AUDIT_PAGE}
          transition={{ duration: 0.5, delay: 1.5 }}
          target="_blank"
          rel="noreferrer"
          className="main-page--audits-link "
        >
          Monitoring report
          <ArrowRight style={{ rotate: '-45deg' }} />
        </motion.a>
        <motion.a
          animate={{
            opacity: isInView ? 1 : 0,
          }}
          viewport={{ margin: '-30%', once: true }}
          href={ROUTES.QUANTSTAMP_AUDIT_PAGE}
          transition={{ duration: 0.5, delay: 1.5 }}
          target="_blank"
          rel="noreferrer"
          className="main-page--audits-link "
        >
          Smart Contracts Audit
          <ArrowRight style={{ rotate: '-45deg' }} />
        </motion.a>
        <motion.a
          animate={{
            x: isInView ? 0 : 50,
            opacity: isInView ? 1 : 0,
          }}
          transition={{ duration: 0.5, delay: 1.5 }}
          href={ROUTES.AUDIT_PAGE}
          target="_blank"
          rel="noreferrer"
          className="main-page--audits-link "
        >
          Audit report
          <ArrowRight style={{ rotate: '-45deg' }} />
        </motion.a>
      </div>
      <div className="main-page--audits-item-group">
        <motion.a
          animate={{
            x: isInView ? 0 : -50,
            opacity: isInView ? 1 : 0,
          }}
          transition={{ duration: 0.5, delay: 2 }}
          href="https://x.com/peckshield"
          target="_blank"
          rel="noopener noreferrer"
          className="main-page--audits-item"
        >
          <span className="main-page--audits-item--heading">
            Secured by
            <img src={peckShield} height={26} draggable={false} alt="" />
          </span>
          <span className="main-page--audits-item--description">
            Leading Web3 Security Company
          </span>
          <span className="main-page--audits-item--link">
            @peckshield on Twitter
            <ArrowRight style={{ rotate: '-45deg' }} />
          </span>
        </motion.a>
        <motion.a
          animate={{
            opacity: isInView ? 1 : 0,
          }}
          transition={{ duration: 0.5, delay: 2 }}
          href="https://x.com/Quantstamp"
          target="_blank"
          rel="noopener noreferrer"
          className="main-page--audits-item"
        >
          <span className="main-page--audits-item--heading">
            Audited by
            <img src={Quantstamp} height={26} draggable={false} alt="" />
          </span>
          <span className="main-page--audits-item--description">
            Global Leader in Blockchain Security
          </span>
          <span className="main-page--audits-item--link">
            @quantstamp on Twitter
            <ArrowRight style={{ rotate: '-45deg' }} />
          </span>
        </motion.a>
        <motion.a
          animate={{
            x: isInView ? 0 : 50,
            opacity: isInView ? 1 : 0,
          }}
          transition={{ duration: 0.5, delay: 2 }}
          href="https://twitter.com/BezuglyiE"
          target="_blank"
          rel="noopener noreferrer"
          className="main-page--audits-item"
        >
          <span className="main-page--audits-item--heading">
            Audited by
            <img
              src={YevheniiBezuhlyiAvatar}
              width={36}
              height={36}
              alt=""
            />{' '}
            Yevhenii Bezuhlyi
          </span>
          <span className="main-page--audits-item--description">
            Security Advisor of RetroBridge
          </span>
          <span className="main-page--audits-item--link">
            @BezuglyiE on Twitter
            <ArrowRight style={{ rotate: '-45deg' }} />
          </span>
        </motion.a>
      </div>
    </div>
  );
}
